// extracted by mini-css-extract-plugin
export var cls1 = "logo-module--cls1--bfee3";
export var cls2 = "logo-module--cls2--10cfc";
export var cls3 = "logo-module--cls3--983d3";
export var cls4 = "logo-module--cls4--67678";
export var siteLogo = "logo-module--siteLogo--903d0";